// extracted by mini-css-extract-plugin
export default {"container":"page404_container__g+SCn","button":"page404_button__oNfNb","glowing-button-85":"page404_glowing-button-85__6G40X"};